import React, { Component } from 'react';
import Lottie from 'react-lottie';
import animationData from '../lottie/3427-ribbon.json';
import GiftImg from '../lottie/gift.png';
import '../Gift.css';
class Gift extends Component {
  render() {
    const defaultOptions = {
      loop: true,
      autoplay: true,
      animationData: animationData,
      rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice'
      }
    };
    return (
      <div>
        <Lottie options={defaultOptions} />
        <div className='wrap'>
          <div className='gift'>
            <img src={GiftImg} alt='gift' />
            <h2>Enjoy Your gift</h2>
          </div>
        </div>
      </div>
    );
  }
}

export default Gift;



// WEBPACK FOOTER //
// ./src/lottie/Gift.js